// React
import React from 'react';

// Reactstrap
import { Col, Row } from 'reactstrap';

import { ListProposals } from '../../../components/ListProposals';

export const CardProposalsAssociates = ({
  history,
  customer,
  isLoading,
  proposalsAssociates,
}) => {
  return (
    <React.Fragment>
      <Row>
        <Col
          xs={12}
          style={{
            marginTop: -24,
          }}
        >
          <div className="text-end">
            <button
              type="button"
              className="btn btn-success add-btn"
              id="create-btn"
              onClick={() => {
                history.push(`/propostas/novo?customer=${customer?.hashid}`);
              }}
            >
              <i className="ri-add-line align-bottom me-1"></i>
              Nova Proposta
            </button>{' '}
          </div>
          <ListProposals
            isLoading={isLoading}
            idCustomer={customer?.hashid}
            proposalsAssociates={proposalsAssociates}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};
